/* eslint no-extend-native: "off" */

import moment from 'moment-timezone';

function isNumeric(num) {
  return !isNaN(parseFloat(num));
}

if (typeof String.prototype.toFormatedDateString !== 'function') {
  String.prototype.toFormatedDateString = function (format = 'ddd ll') {
    return moment(this).format(format);
  };
}

if (typeof Date.prototype.toFormatedDateString !== 'function') {
  Date.prototype.toFormatedDateString = function (format = 'ddd ll') {
    return moment(this).format(format);
  };
}

if (typeof String.prototype.toFormattedDateTimeString !== 'function') {
  String.prototype.toFormattedDateTimeString = function (
    format = 'ddd ll, LT'
  ) {
    return moment(this).format(format);
  };
}

if (typeof Date.prototype.toFormattedDateTimeString !== 'function') {
  Date.prototype.toFormattedDateTimeString = function (format = 'ddd ll, LT') {
    return moment(this).format(format);
  };
}

if (typeof String.prototype.formatWith !== 'function') {
  String.prototype.formatWith = function (args) {
    let i = 0;
    const props = Object.keys(args);
    return this.replace(/%s/g, () => {
      return args[props[i++]];
    });
  };
}

if (typeof Number.prototype.toFormattedMoney !== 'function') {
  Number.prototype.toFormattedMoney = function (
    locale,
    currency,
    defaultValue = ''
  ) {
    return isNumeric(this)
      ? new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
          useGrouping: true,
        }).format(this)
      : defaultValue;
  };
}

if (typeof String.prototype.replaceAll !== 'function') {
  String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
  };
}

if (typeof Date.prototype.toStringFormat !== 'function') {
  Date.prototype.toStringFormat = function (format = 'dddd, DD MMMM YYYY') {
    return moment(this).format(format);
  };
}

if (typeof Array.prototype.groupBy !== 'function') {
  Array.prototype.groupBy = function (prop) {
    return this.reduce(function (groups, item) {
      const val = item[prop];
      groups[val] = groups[val] || [];
      groups[val].push(item);
      return groups;
    }, {});
  };
}

if (typeof Array.prototype.sortBy !== 'function') {
  Array.prototype.sortBy = function (
    field,
    desc = false,
    valueFormatter = (v) => v || ''
  ) {
    return this.concat([]).sort((a, b) => {
      const firstValue = valueFormatter(a[field]);
      const secondValue = valueFormatter(b[field]);
      if (firstValue === secondValue) {
        return 0;
      }
      if (desc) {
        return firstValue > secondValue ? 1 : -1;
      } else {
        return firstValue > secondValue ? -1 : 1;
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/helpers/extensions.js